import React, { useState, useEffect } from 'react';
import { Download, FileText, Calendar } from 'lucide-react';
import Accordion from '../../components/Accordion/Accordion';
import './Documentos.css';

import Doc01 from '../../assets/documents/2025-11-25 - PRODUTO1 - PLANEJAMENTO EXECUTIVO - VO.pdf';
import Doc02 from '../../assets/documents/2025-11-25 - PRODUTO 2 - PLANO DE COMUNICACAO - VO.pdf';

const documents = [
  {
    id: 1,
    title: 'Planejamento Executivo V0 - Produto 01',
    description: 'Detalhadamento das etapas, metodologias e diretrizes que orientarão a elaboração do Plano Municipal de Saneamento Básico do município de Consolação.',
    format: 'PDF',
    filePath: Doc01
  },
  {
    id: 2,
    title: 'Plano de Comunicação V0 - Produto 02',
    description: 'Apresentação da metodologia e dos instrumentos concebidos para assegurar a participação efetiva da sociedade civil no processo de elaboração do Plano Municipal de Saneamento Básico do município de Consolação.',
    format: 'PDF',
    filePath: Doc02
  }
];

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];
  return `${months[date.getMonth()]} de ${date.getFullYear()}`;
};

const Documentos = () => {
  const [documentDates, setDocumentDates] = useState({});

  useEffect(() => {
    const fetchFileDates = async () => {
      const dates = {};

      for (const doc of documents) {
        try {
          const response = await fetch(doc.filePath, { method: 'HEAD' });
          const lastModified = response.headers.get('Last-Modified');

          if (lastModified) {
            dates[doc.id] = formatDate(lastModified);
          } else {
            const filename = doc.filePath.split('/').pop();
            const dateMatch = filename.match(/(\d{4}-\d{2}-\d{2})/);
            if (dateMatch) {
              dates[doc.id] = formatDate(dateMatch[1]);
            } else {
              dates[doc.id] = 'Data não disponível';
            }
          }
        } catch (error) {
          console.error(`Error fetching date for ${doc.filePath}:`, error);
          const filename = doc.filePath.split('/').pop();
          const dateMatch = filename.match(/(\d{4}-\d{2}-\d{2})/);
          if (dateMatch) {
            dates[doc.id] = formatDate(dateMatch[1]);
          } else {
            dates[doc.id] = 'Data não disponível';
          }
        }
      }

      setDocumentDates(dates);
    };

    fetchFileDates();
  }, []);

  const handleDownload = (filePath, fileName) => {
    const link = document.createElement('a');
    link.href = filePath;
    link.download = fileName || filePath.split('/').pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const accordionItems = documents.map((doc) => {
    const date = documentDates[doc.id] || 'Carregando...';

    return {
      title: doc.title,
      metadata: `Atualizado em ${date}`,
      leading: <FileText aria-hidden="true" />,
      content: (
        <div className="document-item">
          <p className="document-item__description">{doc.description}</p>
          <div className="document-item__footer">
            <div className="document-item__meta">
              <span className="document-item__badge document-item__badge--format">
                <FileText aria-hidden="true" />
                {doc.format}
              </span>
              <span className="document-item__badge document-item__badge--date">
                <Calendar aria-hidden="true" />
                {date}
              </span>
            </div>
            <button
              type="button"
              className="document-item__download"
              onClick={() => handleDownload(doc.filePath, `${doc.title}.${doc.format.toLowerCase()}`)}
            >
              <Download aria-hidden="true" />
              <span>Baixar</span>
            </button>
          </div>
        </div>
      )
    };
  });

  return (
    <div className="documents-page">
      <section className="page-hero">
        <div className="page-hero__text">
          <span className="page-hero__eyebrow">Documentos</span>
        </div>
      </section>

      <section className="documents-content">
        <div className="documents-intro">
          <p className="documents-intro__text">
            Consulte materiais tecnicos e registros oficiais que documentam o Plano Municipal de Saneamento Básico.
          </p>
        </div>

        {/* <div style={{
          textAlign: 'center',
          padding: '4rem 2rem',
          color: '#666',
          fontSize: '1.125rem'
        }}>
          <p>Por enquanto não há documentos disponíveis.</p>
          <p style={{ marginTop: '1rem', fontSize: '1rem' }}>
            Em breve, você encontrará aqui documentos técnicos e registros oficiais do PMSB.
          </p>
        </div> */}

        <div className="documents-accordion">
          <Accordion items={accordionItems} />
        </div>
      </section>
    </div>
  );
};

export default Documentos;
